/**
 * Fångar React-renderingsfel så användaren inte ser en vit skärm.
 * Loggar fellet i konsolen för utveckling och visar ett vänligt meddelande
 * med möjlighet att ladda om sidan.
 */

import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack?: string }): void {
    console.error("App crashed:", error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h1>Något gick fel</h1>
          <p>
            Appen kraschade. Försök ladda om sidan. Om det fortsätter, hör av
            dig till{" "}
            <a href="mailto:hej@batterikalkyl.se">hej@batterikalkyl.se</a>.
          </p>
          <button
            type="button"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Ladda om
          </button>
          {this.state.error && (
            <details className="error-details">
              <summary>Teknisk information</summary>
              <pre>{this.state.error.toString()}</pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
